import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rd-maintenance-page',
  template: `
    <div class="flex h-full flex-col items-center justify-center">
      <div
        class="flex w-full max-w-[600px] flex-col gap-y-4 p-8 text-[--text] lg:gap-y-6">
        <h1
          class="m-0 text-[1.5rem] font-bold leading-9 text-[] lg:text-[1.75rem] lg:leading-10">
          {{ 'app.maintenance_page.title' | translate }}
        </h1>

        <p class="m-0">{{ 'app.maintenance_page.text' | translate }}</p>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
})
export class RdMaintenancePagesComponent {}
